import React, { useState } from 'react';

type State = {
  order: any;
  orderNumber: string;
  setOrder(state: any): void;
  setOrderNumber(state: string): void;
};
interface Props {
  children: React.ReactNode;
}
const RefundContext = React.createContext<State | undefined>(undefined);

export function RefundContextProvider({ children }: Props) {
  const [order, setOrder] = useState<any>({
    products: []
  });

  const [orderNumber, setOrderNumber] = useState('');
  return (
    <RefundContext.Provider
      value={{
        order,
        setOrder,
        orderNumber,
        setOrderNumber
      }}
    >
      {children}
    </RefundContext.Provider>
  );
}
export const useRefundContext = () => {
  const context = React.useContext(RefundContext);
  if (!context) {
    throw new Error('useRefundContext debe estar dentro del proveedor dentro de RefundContextProvider');
  }
  return context;
};
